import React, { useMemo } from 'react';
import { createStore, Provider } from 'jotai';
import ContentPanel from './ContentPanel';
import HeaderPanel from './HeaderPanel';
import { isAppModule } from '@src/utils/constants';
import ContentPanelInfiniteScroll from './ContentPanelInfiniteScroll';
import { globalFeatureNames } from '@src/utils/featureToggle/constants';
import { useGlobalFeature } from '@src/globalStore/globalFeatureFlagsStore';

const AiAlerts = (props) => {
  const store = useMemo(() => {
    return createStore();
  }, []);
  const enableDPIAlertPagination = useGlobalFeature(globalFeatureNames.DPI_ALERT_PAGINATION);

  return (
    <Provider store={store}>
      <HeaderPanel {...props} />
      {isAppModule && enableDPIAlertPagination ? <ContentPanelInfiniteScroll /> : <ContentPanel />}
    </Provider>
  );
};

export default AiAlerts;
